import React from "react";
import CookieConsent from "react-cookie-consent";
//import Navbar from "../components/navbar";
import Newnav from "../components/newnav";
//import About from "../components/about";
//import Feature from "../components/feature";
import Extremeevent from "../components/extremeevent";
import FurFairEvent from "../components/furfairevent";
//import ScreenShot from "../components/screenshot";
// import Team from "./components/team";
// import Blog from "./components/blog";
// import Price from "./components/price";
//import Testimonial from "../components/testimonial";
//import Contact from "../components/contact";
//import Subscribe from "../components/subscribe";
import Footer from "../components/footer";
//import Tilt from "react-tilt";
//import { Icon } from "@iconify/react";
//import mobileOutline from "@iconify/icons-ant-design/mobile-outline";
//import qrcodeOutline from "@iconify/icons-ant-design/qrcode-outline";

class Company extends React.Component {
  render() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("home-style");
    document.body.classList.remove("three");
    document.body.classList.remove("home-style-two");
    return (
      <div>
        <Newnav />

        <Extremeevent />
        <FurFairEvent />
        {/*ScreenShot Component*/}
        {/* <Awardcompany /> */}

        {/*Team Component*/}
        {/* <Team /> */}

        {/*Blog Component*/}
        {/* <Blog /> */}

        {/*Price Component*/}
        {/* <Price /> */}

        {/*Testimonial Component*/}
        {/* <Testimonial /> */}

        {/*Contact Component*/}
        {/* <Contact /> */}

        {/*Subscription Component*/}
        {/* <Subscribe /> */}

        {/*Footer Component*/}
        <Footer />
        <CookieConsent
          location="bottom"
          buttonText="Συμφωνώ"
          cookieName="token"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            Αυτός ο ιστότοπος χρησιμοποιεί cookies για να βελτιώσει την εμπειρία
            του χρήστη.{" "}
            <a
              style={{
                fontSize: "10px",
                color: "#fcc11a",
                textDecoration: "none",
              }}
              className="nav-link"
              href={`${process.env.PUBLIC_URL}/cookiePolicy`}
            >
              Πολιτική Cookies
            </a>
          </div>
        </CookieConsent>
      </div>
    );
  }
}

export default Company;



// WEBPACK FOOTER //
// ./src/pages/events.js